<div class="Flexbox Flexbox__box-direction-column panel">
    <ispm-vertical-test-actions-container *ngIf="verticalTestActionsView" class="max-height-35"></ispm-vertical-test-actions-container>
    <ng-content></ng-content>
</div>
